import React, { useEffect } from "react";
import { observer, inject } from "mobx-react";
import cx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import BrandCardHeader from "../../components/BrandCardHeader";
import LockIcon from "@material-ui/icons/Lock";
import CardContent from "@material-ui/core/CardContent";
import { useOverShadowStyles } from "@mui-treasury/styles/shadow/over";
import FormConstructor from "../../organisms/FormConstructor";
import Form from "../../organisms/Form";
import { isField } from "../../utils/fieldTypes";
import changePasswordInputs from "../../utils/formFields/changePasswordInputs";

const useStyles = makeStyles(() => ({
  root: {
    margin: "auto",
    borderRadius: 12
  },
  media: {
    borderRadius: 6
  }
}));

const ChangePasswordForm = inject("store")(
  observer(
    ({
      store,
      store: {
        forms: { changePasswordForm }
      }
    }) => {
      const styles = useStyles();
      const shadowStyles = useOverShadowStyles({ inactive: true });

      useEffect(() => {
        if (!changePasswordForm) {
          const passwordForm = new FormConstructor(
            {
              fields: changePasswordInputs.filter(field => isField(field.type))
            },
            { name: "changePasswordForm" }
          );
          store.setForm("changePasswordForm", passwordForm);
        }
      }, [changePasswordForm]);

      return (
        <Card className={cx(styles.root, shadowStyles.root)}>
          <BrandCardHeader
            extra={"Change Your Password"}
            avatarIcon={<LockIcon />}
          />
          <CardContent>
            {changePasswordForm && changePasswordInputs && (
              <Form
                fields={changePasswordInputs}
                form={changePasswordForm}
                buttonProps={{
                  color: "primary",
                  fullWidth: true,
                  variant: "contained"
                }}
              />
            )}
          </CardContent>
        </Card>
      );
    }
  )
);

export default ChangePasswordForm;
